const steps = [
  {
    number: '01',
    icon: 'ri-search-line',
    title: 'Browse Available Studios',
    description: 'Explore our curated collection of professional studio spaces. Filter by type, location, size, and available equipment to find your perfect match.',
  },
  {
    number: '02',
    icon: 'ri-calendar-check-line',
    title: 'Choose Date &amp; Time',
    description: 'Select your preferred date, time slot, and duration. Real-time availability lets you see exactly what\'s open and plan your shoot with precision.',
  },
  {
    number: '03',
    icon: 'ri-secure-payment-line',
    title: 'Book Instantly Online',
    description: 'Confirm your booking in seconds with our secure checkout. Receive an immediate confirmation with all studio access details and equipment lists.',
  },
  {
    number: '04',
    icon: 'ri-flashlight-line',
    title: 'Show Up &amp; Create',
    description: 'Walk into a fully prepared, professional studio ready to create. No setup delays — everything is configured and waiting for you on arrival.',
  },
];

export default function ProcessSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-amber-600 text-xs font-bold uppercase tracking-widest mb-3 block">
            Simple &amp; Fast
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-stone-900 mb-5">
            How It Works
          </h2>
          <p className="text-stone-500 text-lg max-w-xl mx-auto">
            From discovery to creation in four effortless steps.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, idx) => (
            <div key={step.number} className="relative group">
              {/* Connector line (desktop) */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-px bg-stone-200 z-0 -translate-x-1/2" />
              )}

              <div className="relative bg-stone-50 hover:bg-amber-50 border border-stone-200 hover:border-amber-200 rounded-2xl p-7 transition-all duration-300 h-full">
                {/* Big number watermark */}
                <div className="absolute top-4 right-5 font-serif text-7xl font-bold text-stone-100 leading-none select-none">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="relative z-10 w-12 h-12 flex items-center justify-center bg-amber-100 group-hover:bg-amber-200 rounded-xl mb-5 transition-colors">
                  <i className={`${step.icon} text-amber-600 text-xl`} />
                </div>

                {/* Content */}
                <h3
                  className="relative z-10 font-serif text-xl font-bold text-stone-900 mb-3"
                  dangerouslySetInnerHTML={{ __html: step.title }}
                />
                <p
                  className="relative z-10 text-stone-500 text-sm leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: step.description }}
                />

                {/* Step indicator */}
                <div className="mt-5 flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-amber-500 flex-shrink-0">
                    <span className="text-white text-xs font-bold">{idx + 1}</span>
                  </div>
                  <div className="h-0.5 flex-1 bg-amber-200" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
